import {PlanEditResultConfigItem} from '@/models/PlanEditResultConfigModel';
import Components from '@/enums/PlanEditResultConfigComponentsEnum';
import TabTypes from '@/enums/PlanEditResultConfigTabTypesEnum';

const config: PlanEditResultConfigItem[] = [
    {
        componentKey: Components.Tabs,
        props: {
            depth: 1,
            tabs: [
                {
                    name: 'Общая сводка по сменам',
                    type: TabTypes.User,
                    content: [
                        {
                            componentKey: Components.PlanResSummaryIndicator,
                            idGridConfigItem: null,
                            requestParams: [],
                        },
                        {
                            componentKey: Components.PlanResSummaryOrderBalance,
                            idGridConfigItem: null,
                            requestParams: [],
                            isCompressed: false,
                        },
                        {
                            componentKey: Components.PlanResSummaryPlywoodBalance,
                            idGridConfigItem: null,
                            requestParams: [],
                            isCompressed: false,
                        },
                        {
                            componentKey: Components.PlanResSummaryWarehouseVeneer,
                            idGridConfigItem: null,
                            requestParams: [],
                            isCompressed: false,
                        },
                    ],
                },
                {
                    name: 'Documents.PlanRes.ShiftTabs',
                    type: TabTypes.Shift,
                    content: [
                        {
                            componentKey: Components.Tabs,
                            props: {
                                depth: 2,
                                tabs: [
                                    {
                                        name: 'Движение по складам шпона',
                                        type: TabTypes.User,
                                        content: [
                                            {
                                                componentKey: Components.Tabs,
                                                props: {
                                                    depth: 3,
                                                    tabs: [
                                                        {
                                                            name: 'Все склады',
                                                            type: TabTypes.User,
                                                            content: [
                                                                {
                                                                    componentKey:
                                                                        Components.PlanResByShiftWarehouseVeneer,
                                                                    idGridConfigItem: null,
                                                                    requestParams: [
                                                                        {
                                                                            key: 'shiftIndex',
                                                                            value: -1,
                                                                        },
                                                                        {
                                                                            key: 'idWarehouseVeneer',
                                                                            value: null,
                                                                        },
                                                                    ],
                                                                    isCompressed: false,
                                                                    props: {
                                                                        data: {
                                                                            idWarehouseVeneer: null,
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        {
                                                            name: 'Documents.PlanRes.WarehouseVeneerTabs',
                                                            type: TabTypes.WarehouseVeneer,
                                                            content: [
                                                                {
                                                                    componentKey:
                                                                        Components.PlanResByShiftWarehouseVeneer,
                                                                    idGridConfigItem: null,
                                                                    isCompressed: false,
                                                                    requestParams: [
                                                                        {
                                                                            key: 'shiftIndex',
                                                                            value: -1,
                                                                        },
                                                                        {
                                                                            key: 'idWarehouseVeneer',
                                                                            value: -1,
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        name: 'Обработка фанеры',
                                        type: TabTypes.User,
                                        content: [
                                            {
                                                componentKey: Components.PlanResByShiftOrderBalance,
                                                requestParams: [
                                                    {
                                                        key: 'shiftIndex',
                                                        value: -1,
                                                    },
                                                ],
                                                idGridConfigItem: null,
                                                isCompressed: false,
                                            },
                                            {
                                                componentKey: Components.PlanResByShiftPlywoodBalance,
                                                requestParams: [
                                                    {
                                                        key: 'shiftIndex',
                                                        value: -1,
                                                    },
                                                ],
                                                idGridConfigItem: null,
                                                isCompressed: false,
                                            },
                                            {
                                                componentKey: Components.PlanResByShiftRecommendation,
                                                requestParams: [
                                                    {
                                                        key: 'shiftIndex',
                                                        value: -1,
                                                    },
                                                ],
                                                idGridConfigItem: null,
                                                isCompressed: false,
                                            },
                                        ],
                                    },
                                    {
                                        name: 'Documents.PlanRes.EquipmentTabs',
                                        type: TabTypes.Equipment,
                                        content: [
                                            {
                                                componentKey: Components.EquipmentType,
                                                requestParams: [
                                                    {
                                                        key: 'shiftIndex',
                                                        value: -1,
                                                    },
                                                    {
                                                        key: 'idEquipmentType',
                                                        value: -1,
                                                    },
                                                ],
                                                idGridConfigItem: null,
                                                isCompressed: false,
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    ],
                },
            ],
        },
    },
];

export default config;
